($ => {
    $(document).ready(function () {
        const SlickCarousel = {

            init() {
                $('.js-complementary-carousel').slick({
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: true,
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: true,
                            }
                        }
                    ]
                });

            },
        };

        const StickyMenu = {
            init() {
                console.log('Testing') ;
            }
        };

        SlickCarousel.init()
        StickyMenu.init()
    });

})(jQuery);